import crudHandlers from "./_crud";

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    
    default:

      state = crudHandlers(state, action, 'personal_transportation')

      return state
  }
}